// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box-card .inputs-wrapper {\n  background: #f5f5f5;\n  border-bottom: 1px solid gainsboro;\n}\n.box-card .inputs-wrapper .v-input {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 0px;\n          flex: 1 1 0px;\n}", ""]);
// Exports
module.exports = exports;
